
import { Base } from '../base-component';

import './horizontal-buttons.component.scss';

export class HorizontalButtons extends Base {

	constructor(element: Element){

		super(element);
				
	}

	init(){}

	bindEvents() {}
	
}



// WEBPACK FOOTER //
// ./components/horizontal-buttons/horizontal-buttons.component.ts